__turbopack_context__.v({
  "applyBtn": "jobs-module-scss-module__wzDRZa__applyBtn",
  "checkbox": "jobs-module-scss-module__wzDRZa__checkbox",
  "checkboxList": "jobs-module-scss-module__wzDRZa__checkboxList",
  "checkboxRow": "jobs-module-scss-module__wzDRZa__checkboxRow",
  "content": "jobs-module-scss-module__wzDRZa__content",
  "emptyState": "jobs-module-scss-module__wzDRZa__emptyState",
  "emptySub": "jobs-module-scss-module__wzDRZa__emptySub",
  "emptyTitle": "jobs-module-scss-module__wzDRZa__emptyTitle",
  "filterCard": "jobs-module-scss-module__wzDRZa__filterCard",
  "filterHeading": "jobs-module-scss-module__wzDRZa__filterHeading",
  "filterInput": "jobs-module-scss-module__wzDRZa__filterInput",
  "filterLabel": "jobs-module-scss-module__wzDRZa__filterLabel",
  "filterSection": "jobs-module-scss-module__wzDRZa__filterSection",
  "industryTag": "jobs-module-scss-module__wzDRZa__industryTag",
  "jobBody": "jobs-module-scss-module__wzDRZa__jobBody",
  "jobCard": "jobs-module-scss-module__wzDRZa__jobCard",
  "jobCompany": "jobs-module-scss-module__wzDRZa__jobCompany",
  "jobDesc": "jobs-module-scss-module__wzDRZa__jobDesc",
  "jobFooter": "jobs-module-scss-module__wzDRZa__jobFooter",
  "jobList": "jobs-module-scss-module__wzDRZa__jobList",
  "jobLogo": "jobs-module-scss-module__wzDRZa__jobLogo",
  "jobLogoFallback": "jobs-module-scss-module__wzDRZa__jobLogoFallback",
  "jobLogoWrap": "jobs-module-scss-module__wzDRZa__jobLogoWrap",
  "jobMeta": "jobs-module-scss-module__wzDRZa__jobMeta",
  "jobSalary": "jobs-module-scss-module__wzDRZa__jobSalary",
  "jobSkeleton": "jobs-module-scss-module__wzDRZa__jobSkeleton",
  "jobTitle": "jobs-module-scss-module__wzDRZa__jobTitle",
  "jobTopRow": "jobs-module-scss-module__wzDRZa__jobTopRow",
  "main": "jobs-module-scss-module__wzDRZa__main",
  "pageBtn": "jobs-module-scss-module__wzDRZa__pageBtn",
  "pageBtnActive": "jobs-module-scss-module__wzDRZa__pageBtnActive",
  "pageWrapper": "jobs-module-scss-module__wzDRZa__pageWrapper",
  "pagination": "jobs-module-scss-module__wzDRZa__pagination",
  "resetBtn": "jobs-module-scss-module__wzDRZa__resetBtn",
  "resultsCount": "jobs-module-scss-module__wzDRZa__resultsCount",
  "salaryRow": "jobs-module-scss-module__wzDRZa__salaryRow",
  "saveBtn": "jobs-module-scss-module__wzDRZa__saveBtn",
  "saveBtnActive": "jobs-module-scss-module__wzDRZa__saveBtnActive",
  "searchBar": "jobs-module-scss-module__wzDRZa__searchBar",
  "searchBtn": "jobs-module-scss-module__wzDRZa__searchBtn",
  "searchIcon": "jobs-module-scss-module__wzDRZa__searchIcon",
  "searchInput": "jobs-module-scss-module__wzDRZa__searchInput",
  "shimmer": "jobs-module-scss-module__wzDRZa__shimmer",
  "sidebar": "jobs-module-scss-module__wzDRZa__sidebar",
  "sortActive": "jobs-module-scss-module__wzDRZa__sortActive",
  "sortBtn": "jobs-module-scss-module__wzDRZa__sortBtn",
  "sortBtns": "jobs-module-scss-module__wzDRZa__sortBtns",
  "toolbar": "jobs-module-scss-module__wzDRZa__toolbar",
  "verifiedBadge": "jobs-module-scss-module__wzDRZa__verifiedBadge",
});
